var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobRunSuccessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21790_18415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92456 0.0859375C4.1773 0.0859375 0.31543 3.9478 0.31543 8.69507C0.31543 13.4423 4.1773 17.3042 8.92456 17.3042C13.6718 17.3042 17.5337 13.4423 17.5337 8.69507C17.5337 3.9478 13.6718 0.0859375 8.92456 0.0859375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65039 9.31152L7.09245 11.7536L13.1976 5.64844",
    stroke: "#20BF6B",
    strokeWidth: 1.22103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21790_18415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2183,
    height: 17.2183,
    fill: "white",
    transform: "translate(0.475586 0.257812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobRunSuccessIcon);
export default __webpack_public_path__ + "static/media/JobRunSuccessIcon.1efcf30d206670e74b126d092e921fd0.svg";
export { ForwardRef as ReactComponent };